module.exports = __webpack_public_path__ + "img/DE02720.4d10990d.png";